export const filter = {
    user_id: null, 
    priority: '', 
    filial_id: null, 
    label_ids : [],  
};
  